import "../../../../App.css"
import { useEffect, useState } from 'react';
import NavbarVerical from '../../../Navbar/navbarVertical';
import { Card, Form, Row, Col, Button, DropdownButton, Table } from 'react-bootstrap';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { postSocialReservation, geteSocialReservation, editSocialReservation } from "../../../api/socialreservation";

function SocialReservation() {
    const [description, setDescription] = useState("");
    const [socialreservations, setSocialReservations] = useState([]);
    const [isEditing, setIsEditing] = useState(false);
    const [editingId, setEditingId] = useState(null);
    const [errors, setErrors] = useState({});

    const token =
        typeof window !== "undefined" ? localStorage.getItem("token") : null;


    useEffect(() => {
        const fetchSocialReservations = async () => {
            try {
                const response = await geteSocialReservation(token);
                setSocialReservations(response.data);
            } catch (error) {
                console.error("Error fetching social reservations:", error);
            }
        };
        fetchSocialReservations();
    }, [token]);


    const handleSubmit = async (event) => {
        event.preventDefault();

        const newErrors = {};
        if (!description.trim()) {
            newErrors.description = "Description is Required";
        } else if (!/^[A-Za-z\s]+$/.test(description)) {
            newErrors.description = "Only letters and spaces are allowed";
        }

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }

        const requestBody = { description };
        try {
            if (isEditing) {
                const response = await editSocialReservation(editingId, requestBody, token);
                toast.success("Social Reservation updated successfully!");
            } else {
                const response = await postSocialReservation(requestBody, token);
                toast.success("Social Reservation created successfully!");
            }

            const updatedResponse = await geteSocialReservation(token);
            setSocialReservations(updatedResponse.data);
            setDescription("");
            setIsEditing(false);
            setEditingId(null);
        } catch (error) {
            console.error("Error creating/updating social reservation:", error);
            toast.error("Failed to create/update Social Reservation.");
        }
    };

    const handleEdit = (id, description) => {
        setDescription(description);
        setIsEditing(true);
        setEditingId(id);
    };

    const handleCancel = () => {
        setDescription("");
        setIsEditing(false);
        setErrors({});
    }

    return (
        <>
            <NavbarVerical />
            <div className="content-area">
                <Card>
                    <Card.Body>
                        <p style={{ color: "#6e48aa", fontWeight: "600", borderBottom: "1px solid #6e48aa" }}>Social Reservation</p>
                        <Form>
                            <Row className='mt-4'>
                                <Col>
                                    <Row className="mb-3">

                                        <Form.Label
                                            className="col-sm-3 col-form-label form-label"
                                            htmlFor="courseDropdown"
                                        >
                                            Description<span className="text-danger">*</span>
                                        </Form.Label>
                                        <Col sm={7} className="mb-3 mb-lg-0">
                                            <Form.Control
                                                as="textarea"
                                                rows={3}
                                                placeholder="Enter Description"
                                                value={description}
                                                //onChange={(e) => setDescription(e.target.value)}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    setDescription(value);
                                                    if (!/^[A-Za-z\s]+$/.test(value)) {
                                                        setErrors(prev => ({ ...prev, description: "Only letters and spaces are allowed" }));
                                                    } else if (value.trim() === "") {
                                                        setErrors(prev => ({ ...prev, description: "Category Type is Required" }));
                                                    } else {
                                                        setErrors(prev => ({ ...prev, description: "" }));
                                                    }
                                                }}
                                            />
                                            {errors.description && (
                                                <div
                                                    style={{
                                                        color: "red",
                                                        fontSize: "13px",
                                                        marginTop: "3px",
                                                    }}
                                                >
                                                    {errors.description}
                                                </div>
                                            )}
                                        </Col>
                                    </Row>
                                </Col>
                                <Col>
                                    <Row>
                                        <Table responsive striped bordered hover>
                                            <thead>
                                                <tr>
                                                    <th>Description</th>
                                                    <th>Edit</th>

                                                </tr>
                                            </thead>
                                            <tbody>
                                                {socialreservations.map((reservation, index) => (
                                                    <tr key={index}>
                                                        <td>{reservation.description}</td>
                                                        <td>
                                                            <Button variant="secondary" onClick={() => handleEdit(reservation.id, reservation.description)}>
                                                                <i className="bi bi-pencil-fill me-2" />Edit</Button>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>

                                        </Table>
                                    </Row>
                                </Col>
                            </Row>

                            <Row>
                                <Col className="d-flex align-items-center justify-content-center mb-3">
                                    <Button variant="primary" type="button"
                                        onClick={handleSubmit}
                                    >
                                        {isEditing ? "Update" : "Submit"}
                                    </Button>
                                    <ToastContainer />
                                    <Button variant="secondary" type="button" style={{ marginLeft: "10px" }}
                                        onClick={handleCancel}
                                    >
                                        Cancel
                                    </Button>
                                </Col>
                            </Row>
                        </Form>
                    </Card.Body>
                </Card>
            </div>
        </>
    );
}

export default SocialReservation;